import React from "react";
import "./App.css"

function Footer(){
    return(
<h4>This site was coded by Mehrnaz Sadeghian</h4>
    );
}
export default Footer;